import { Link } from '@inertiajs/react'
import { Scale } from 'lucide-react'
import EvalVerdictDetails, { type EvalVerdict } from '@/frontend/components/Eval/EvalVerdictDetails'
import { RES_PT, SAT_PT, RES_CHIP, SAT_CHIP, SEV_DOT, SEV_PT, severityKey } from '@/frontend/components/Eval/evalStyles'

export interface SessionEvalVerdict extends EvalVerdict {
  judgeVersion: string
  judgedAt: string | null
}

// Collapsible eval verdict panel for the telemetry session page. Renders only
// when the fleet-eval worker has judged this session.
export default function SessionEvalPanel({ verdict, digitalWorkerId }: { verdict: SessionEvalVerdict; digitalWorkerId: string }) {
  const sk = severityKey(verdict.severity, verdict.problem)
  return (
    <details className="mb-6 ml-8 mr-4 rounded-lg border bg-card">
      <summary className="flex cursor-pointer flex-wrap items-center gap-2 px-3 py-2 text-sm">
        <Scale className="h-4 w-4 text-muted-foreground" />
        <span className="font-medium">Eval da sessão</span>
        <span className={`h-2.5 w-2.5 rounded-full ${SEV_DOT[sk] ?? 'bg-zinc-400'}`} title={`severidade: ${SEV_PT[sk]} — o quão sério foi o pior problema que rolou na conversa`} />
        {verdict.lenses?.outcome?.task_summary && (
          <span className="max-w-md truncate text-xs text-muted-foreground" title={verdict.lenses.outcome.task_summary}>
            {verdict.lenses.outcome.task_summary}
          </span>
        )}
        {verdict.resolution && verdict.resolution !== 'no_task' && (
          <span className={`rounded border px-1.5 py-0.5 text-[10px] font-medium uppercase ${RES_CHIP[verdict.resolution] ?? ''}`}>
            {RES_PT[verdict.resolution] ?? verdict.resolution}
          </span>
        )}
        {verdict.satisfaction && SAT_CHIP[verdict.satisfaction] && verdict.satisfaction !== 'neutral' && (
          <span className={`rounded border px-1.5 py-0.5 text-[10px] font-medium uppercase ${SAT_CHIP[verdict.satisfaction]}`}>
            {SAT_PT[verdict.satisfaction]}
          </span>
        )}
        {verdict.masked && (
          <span className="cursor-help rounded bg-red-600 px-1.5 py-0.5 text-[10px] font-semibold uppercase text-white"
                title="Agente declarou sucesso ao cliente, mas os outputs das tools mostram falha — o desfecho mostra a versão do cliente; evidência na seção Execução abaixo.">sucesso falso</span>
        )}
        {verdict.corrections > 0 && (
          <span className="rounded border px-1.5 py-0.5 text-[10px]">{verdict.corrections} correções</span>
        )}
        <span className="ml-auto text-[10px] text-muted-foreground">
          {verdict.judgeVersion}{verdict.judgedAt ? ` · ${new Date(verdict.judgedAt).toLocaleString('pt-BR')}` : ''}
        </span>
      </summary>
      <div className="border-t px-3 py-3">
        <EvalVerdictDetails verdict={verdict} />
        <Link href={`/cc/eval/${digitalWorkerId}`} className="mt-3 inline-block text-xs text-primary hover:underline">
          ver eval completo do colaborador →
        </Link>
      </div>
    </details>
  )
}
